<div class="image" [ngClass]="{loaded: imageLoaded, 'image--placeholder' : isPlaceholder}" #imageWrapper>
  <figure >
    <picture>
      <img *ngIf="image" class="image__img"
           [style]="{'background-color' : backgroundColor}"
           [src] ="thumbnailSrc"
           [srcset]="srcSet"
           [alt]="image.info.alttext"
           [sizes]="imageViewportSize"
           (load)="onImageLoaded()"
           draggable="false"
      >
      <div class="image__preloader" [style]="{'background-color' : backgroundColor}"></div>
    </picture>
    <!--    <figcaption *ngIf="image.info.caption">{{image.info.caption}}</figcaption>-->
  </figure>
</div>
